import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalRef, SidePanel } from '@anthem/uxd/modal';
import { EventHandler } from '../../../../../../../common/services/eventHandler';
import { AppSession } from '../../../../../../../common/values/appSession';
import { SliderDirection } from '../../../../../constants/common';
import { BaseComponent } from '../../../../core/baseCmp';

@Component({
  moduleId: module.id,
  selector: 'app-fc-sbhc-slider-cmp',
  templateUrl: './sbhcSliderCmp.html'
})
export class SBHCSliderComponent extends BaseComponent {
  sidePanelRef: ModalRef<HTMLElement>;
  @ViewChild('sbhcPanelTemplate') sbhcPanelTemplate: TemplateRef<HTMLElement>;

  constructor(
    private _route: ActivatedRoute,
    private _eventHandler: EventHandler,
    private _appSession: AppSession,
    private _sidePanel: SidePanel
  ) {
    super(_route, _eventHandler, _appSession);
  }

  openSlider() {
    this.sidePanelRef = this._sidePanel.open(SliderDirection.RIGHT, this.sbhcPanelTemplate);
  }

  closeSlider() {
    if (this.sidePanelRef) {
      this.sidePanelRef.close();
    }
  }
}
